import { Box, Typography } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import { DateTime } from "luxon";
import Boundary from "models/geospatial/boundary";
import Point from "models/geospatial/point";
import Input from "models/input/input";
import React from "react";
import Metadata from "../metadata";

const Footer = ({
  input,
  boundaries,
  points,
  searchCard = false,
}: Readonly<{
  input: Input;
  boundaries: Boundary[];
  points: Point[];
  searchCard?: boolean;
}>) => {
  const theme = useEasierTheme();
  return (
    <Box
      sx={{
        p: 2,
        background: ["FAF-nt", "nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? "#454347"
          : theme?.Colour.SurfaceContainerHigh(),
        borderRadius: ["FAF-nt", "nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? undefined
          : "0px 0px 8px 8px",
        color: ["FAF-nt", "nrdata-orig"].includes(
          process.env.REACT_APP_STYLING_THEME ?? "",
        )
          ? "#fff"
          : undefined,
      }}
    >
      <Box display="inline-flex" width="100%">
        <Typography
          width="50%"
          p={1}
          color="inherit"
          sx={{
            fontWeight: 400,
            fontSize: "0.813rem",
            letterSpacing: "0.3px",
            lineHeight: "1.6",
          }}
        >
          Registered date:{" "}
          {DateTime.fromISO(input.created_at)
            .toLocal()
            .toFormat(
              (process.env.REACT_APP_DATE_FORMAT ?? "dd/MM/yyyy") +
                " " +
                (process.env.REACT_APP_TIME_FORMAT ?? " HH:mm:ss"),
            )}
        </Typography>
        <Typography
          width="50%"
          p={1}
          color="inherit"
          sx={{
            fontWeight: 400,
            fontSize: "0.813rem",
            letterSpacing: "0.3px",
            lineHeight: "1.6",
          }}
        >
          Last updated:{" "}
          {DateTime.fromISO(input.updated_at)
            .toLocal()
            .toFormat(
              (process.env.REACT_APP_DATE_FORMAT ?? "dd/MM/yyyy") +
                " " +
                (process.env.REACT_APP_TIME_FORMAT ?? " HH:mm:ss"),
            )}
        </Typography>
      </Box>
      {!searchCard && (
        <Metadata
          input={input}
          boundaries={boundaries}
          points={points}
          templates={[]}
          placement="bottom"
        />
      )}
      {["FAF-nt", "nrdata-orig"].includes(
        process.env.REACT_APP_STYLING_THEME ?? "",
      ) && (
        <Typography
          px={1}
          color="inherit"
          sx={{
            fontWeight: 400,
            fontSize: "0.813rem",
            letterSpacing: "0.3px",
            lineHeight: "1.6",
          }}
        >
          Input id:{` ${input.input_id}`}
        </Typography>
      )}
    </Box>
  );
};

export default Footer;
